module.exports = __webpack_public_path__ + "static/media/header-ill.acad3496.svg";